module.exports = __webpack_public_path__ + "img/2d32a0f.png";